import { render, staticRenderFns } from "./step_1.1.vue?vue&type=template&id=6ff4a060"
import script from "./step_1.1.vue?vue&type=script&lang=js"
export * from "./step_1.1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports